import { render, staticRenderFns } from "./transferDetailReportList.vue?vue&type=template&id=aa8895de"
import script from "./transferDetailReportList.vue?vue&type=script&lang=js"
export * from "./transferDetailReportList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports